import React, { useContext, useEffect } from 'react'
import { store } from '../../components/HOC/State';
import { translate } from '../translate';
import styles from './rent.module.css'

export default function RentPromo() {
   const {selectedLang} = useContext(store)
  
      let lang = translate[selectedLang]

    function restart(e) {
        e.target.currentTime = 0;

        e.target.play();
    }

  return (
    <div className={styles['promo-div']}>
        <div className={styles['text']}><div>{lang.tr_estateRental}</div></div>
        <img src="/rent.jpg" alt="rent" /> 
    </div>
  )
}
